<template>
	<Modal v-model="isVisible" class="decline-job-modal" @toggle="close">
		<template #title>Decline Job</template>
		<template #content>
			<p v-if="isTrialing">
				You have been selected by a studio as the right fit for this job. You are the only person receiving this job offer at this time. If you decline, the job will be offered to the next person on the studio's list and you won't be able to change your response.
			</p>
			<p v-else>
				We're sorry this job offer wasn't a good fit for you. In order to better meet the needs of our photographers, can you share with us why this job wasn't a good fit for you?
			</p>
			<div class="mt-28">
				<div v-for="(value, name, i) in declineReasons" :key="`dr${i}`" class="checkbox mt-8">
					<input :id="`declineReason${i}`" type="checkbox" v-model="checkedDeclineReasons" :value="name" />
					<label class="checkbox-content" :for="`declineReason${i}`">
						<div class="field-input">
							<icon-check />
						</div>
						{{ value }}
					</label>
				</div>
			</div>
			<div v-if="checkedDeclineReasons.includes('noLongerAvailable')" class="mt-16 pt-16 border-top">
				<div class="checkbox">
					<input type="checkbox" v-model="setUnavailable" id="setUnavailable">
					<label class="checkbox-content" for="setUnavailable">
						<div class="field-input">
							<icon-check />
						</div>
						Should we remove availability for this date?
					</label>
				</div>
			</div>
			<div v-if="checkedDeclineReasons.includes('other')" class="mt-16">
				<input v-model="declineReasonOther" type="text" placeholder="Enter reason for declining..">
			</div>
			<div class="flex-col sm-flex-row flex-split wrap gap-16 mt-32">
				<button v-if="isFreeJob" class="btn btn-green" :job="job" @click="goToJobDetailsPage">View Job Details</button>
				<UpgradeButton v-else-if="!canAcceptJob" class="btn btn-green" :job="job"><icon-check-slim class="mr-8"/>Upgrade now to view job details</UpgradeButton>
				<button class="btn btn-hover-red sm-align-right" :disabled="!checkedDeclineReasons.length" @click="declineJob">
					<icon-x />Decline Job
				</button>
			</div>
		</template>
	</Modal>
</template>

<script>

export default {
	name: 'DeclineJobModal',
	data() {
		return {
			isSending: false,
			setUnavailable: false,
			checkedDeclineReasons: [],
			declineReasonOther: '',
			declineReasonsPaid: {
				noLongerAvailable: "I'm no longer available",
				tooFarWay: 'The job is too far away',
				other: 'Other',
			},
			declineReasonsTrial: {
				noLongerAvailable: "I'm no longer available",
				tooFarWay: 'The job is too far away',
				doNotWantToPayForSubscription: "I don't want to pay for a subscription",
				notSureIfItIsLegit: 'Not sure if this is legit',
				other: 'Other',
			}
		}
	},
	methods: {
		close() {
			this.$store.commit('jobs/setDecliningJob', false);
		},
		async declineJob() {
			this.isSending = true;
			const payload = {
				job: this.job,
				decliningResponse: this.decliningResponse,
				setUnavailable: this.setUnavailable,
			};
			await this.$store.dispatch('jobs/employeeDeclineOffer', payload);
			this.$store.commit('cache/removeByID', { name: 'dashboardJobsOfferedMe', id: this.job.id });
			this.isSending = false;

			// TODO; test this
			if (this.$route.name == 'job') {
				this.$router.push({ name: this.$routes.Dashboard.name });
			}
			this.close();
		},
		goToJobDetailsPage() {
			if (this.canAcceptJob) {
				this.$router.push({ name: this.$routes.JobDetails.name, params: { jobId: this.job.id } });
				this.$store.commit('jobs/setDecliningJob', false);
			}
		},
	},
	computed: {
		isVisible: {
			get() {
				return this.job ? true : false;
			},
			set() {
				// no setter
			},
		},
		job() {
			return this.$store.getters['jobs/decliningJob'];
		},
		subscription() {
			return this.$store.getters['subscriptions/current'];
		},
		isTrialing() {
			return !!this.subscription?.isTrialing;
		},
		isFreeJob() {
			const freeJob = this.$store.getters['jobs/freeJobData'].freeJob;

			return freeJob && freeJob.id == this.job.id;
		},
		canAcceptJob() {
			return this.isTrialing ? this.isFreeJob : true;
		},
		declineReasons() {
			return this.isTrialing ? this.declineReasonsTrial : this.declineReasonsPaid;
		},
		decliningResponse() {
			if (!this.checkedDeclineReasons) {
				return false;
			}
			const response = [];

			for (const value of this.checkedDeclineReasons) {
				if (value == 'other') {
					response.push({
						type: 'other',
						details: this.declineReasonOther,
					});
				} else {
					const obj = {
						type: value,
						details: this.declineReasons[value],
					};
					response.push(obj);
				}
			}

			return response;
		},
	},
}
</script>